import { atom } from 'nanostores';

import type { ICD10CodeT } from '@/entities/labs';
import type { SourceProposedActionT } from '@/shared/lib';

export interface LabOrderWizardPrefill {
  labTestId: string;
  labTestName?: string;
  icdCodes?: ICD10CodeT[];
  notes?: string;
  priority?: boolean;
  sourceProposedAction?: SourceProposedActionT;
}

/**
 * One-shot prefill payload for the LabOrderWizard overlay.
 *
 * Consumed once when the wizard mounts/opens, then cleared.
 * Do not persist this value.
 */
export const $labOrderWizardPrefill = atom<LabOrderWizardPrefill | null>(null);

export function setLabOrderWizardPrefill(prefill: LabOrderWizardPrefill) {
  $labOrderWizardPrefill.set(prefill);
}

export function clearLabOrderWizardPrefill() {
  $labOrderWizardPrefill.set(null);
}
